import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import BlogCard from "./BlogCard";
import Header from "./Header";
import Footer from "./Footer";
import Dynamicmeta from "./Dynamicmeta";
//import "../css/style.css";

const blogPosts = [
  {
    image: "/images/colortool.webp",
    link: "/colortool.html",
    title: "Color Picker Tool",
    author: "Codeinputs",
    description: "Color Code Finder is your ultimate tool for selecting, identifying, and copying color codes..."
  },
  {
    image: "/images/Email_accounts.webp",
    link: "/email_accounts.html",
    title: "How to Create an Email Account in cPanel | Step-by-Step Guide",
    author: "Codeinputs",
    description: "Managing email accounts through cPanel is an essential skill for website owners and businesses..."
  },
  {
    image: "/images/jpeg_to_pdf.webp",
    link: "/jpeg_to_pdf.html",
    title: "JPEG to PDF Converter | Fast, Free & High-Quality Image to PDF Tool",
    author: "Codeinputs",
    description: "Converting JPEG to PDF is quick, easy, and efficient with the right tool..."
  },
  {
    image: "/images/Adobe_pdf_tool.webp",
    link: "/png_to_pdf.html",
    title: "PNG to PDF Converter | Fast, Free & High-Quality Image to PDF Tool",
    author: "Codeinputs",
    description: "Our PNG to PDF Converter is a free and easy-to-use online tool that lets you quickly convert PNG images..."
  },
  {
    image: "/images/Adobe_pdf.webp",
    link: "/adobe_pdf.html",
    title: "Adobe PDF Tools: Features, Benefits & Future Innovations | Complete Guide",
    author: "Codeinputs",
    description: "In today’s digital landscape, efficient document management is essential for individuals and businesses..."
  },
  {
    image: "/images/dns.webp",
    link: "/dns.html",
    title: "What is DNS? Understanding the Domain Name System & How It Works",
    author: "Codeinputs",
    description: "The Domain Name System (DNS) is like the internet’s phonebook..."
  }
];

const MainComponent = () => {
  return (
    <>
      <Dynamicmeta/>
      <Header />
      <div className="full-div">
        <Container className="mt-4 mb-4">
          {blogPosts.map((post, index) => (
            <Row key={index} className="justify-content-center">
              <Col md={8}>
                <BlogCard {...post} />
              </Col>
            </Row>
          ))}
        </Container>
      </div>
      <Footer />
    </>
  );
};

export default MainComponent;
